import { z } from 'zod';

import {
  EBlockType,
  EContentType,
  EPagesRadioButtonOptions,
  EPagesTemplateOptions,
  EPagesVisibilityOptions
} from './constants';
import { pageFormSchema } from './validation-schema';

export const defaultPageFormValues: z.infer<typeof pageFormSchema> = {
  pageName: '',
  pageIcon: '',
  slug: '',
  pageTemplate: EPagesTemplateOptions.CONTENT,
  priority: 0,
  subPagePriority: 0,
  visibility: EPagesVisibilityOptions.PUBLIC,
  metadataImage: '',
  metadataDescription: '',
  state: EPagesRadioButtonOptions.HIDDEN,
  publishDate: '',
  isPublishDateEnabled: false,
  isSubPage: false,
  parentPageId: undefined,
  blocksV2: [
    {
      type: EBlockType.CONTENTS_PREVIEW,
      contentType: EContentType.ARTICLE,
      title: 'ARTICLES',
      maxItems: 1000,
      itemsPerRow: 2
    },
    {
      type: EBlockType.CONTENTS_PREVIEW,
      contentType: EContentType.NEWS,
      title: 'NEWS',
      maxItems: 1000,
      itemsPerRow: 1
    }
  ]
};
